// Night-theme foreground: white, softened a touch so it doesn't glare on the deep
// circle colors. Used for every dark circle's label/meta and the open list page text.
const NIGHT_TEXT = 'rgba(255, 255, 255, 0.9)'

export default {
    // Light-theme brand color: top logo + header icons.
    BRAND: '#3d3289',

    BLUE: '#b5c9f0',
    RED: '#ff9cb7',

    GRAY: '#5c7489',
    GREEN: '#084e62',
    DARK_GREEN: '#096b89',
    EXTRA_DARK_GREEN: '#0a5671',

    // How many palette slots the id hash derives a color from — frozen at the
    // original 14 so existing (unpicked) lists keep their hue forever; hues
    // added later are reachable only by picking them in the color panel.
    // Never lower this, and never reorder/remove existing entries below —
    // stored picks are palette indexes.
    HASHED_HUES: 14,

    // Light-theme circle palette: soft pastels on the #efecf3 background, each
    // paired with a dark version of its own hue for the label/meta text. The four
    // blue/cyan/green entries were desaturated (to S~0.5, L~0.86) so the whole set
    // reads as one consistent pastel family; the rest are used as supplied.
    LIST_PALETTE: [
        { bg: '#d0d0d0', text: '#525252' }, // gray
        { bg: '#ded7c2', text: '#76642d' }, // sand
        { bg: '#dccbe5', text: '#5d2d76' }, // mauve
        { bg: '#e8e2c5', text: '#766a2d' }, // straw
        { bg: '#f3c7db', text: '#83214d' }, // pink
        { bg: '#d6cfed', text: '#3e2d77' }, // lavender
        { bg: '#c9ddd5', text: '#2d7659' }, // sage
        { bg: '#c6dbe7', text: '#2d5c76' }, // powder blue
        { bg: '#ecd2b9', text: '#805123' }, // peach
        { bg: '#fccfca', text: '#832a21' }, // salmon
        { bg: '#c9d9ed', text: '#214c83' }, // periwinkle (adjusted)
        { bg: '#c9e3ed', text: '#216783' }, // sky (adjusted)
        { bg: '#c9eded', text: '#218183' }, // cyan (adjusted)
        { bg: '#deedc9', text: '#598321' }, // green (adjusted)
        // Pick-only hues (index 14+, added 1.3.0): same pastel family —
        // bg hsl(h, 50%, 86%), text hsl(h, 60%, 32%). Append-only (see HASHED_HUES).
        { bg: '#edc9c9', text: '#832121' }, // red
        { bg: '#edd5c9', text: '#834121' }, // orange
        { bg: '#ede0c9', text: '#835f21' }, // amber
        { bg: '#ededc9', text: '#838321' }, // yellow
        { bg: '#e6edc9', text: '#6f8321' }, // lime
        { bg: '#d2edc9', text: '#398321' }, // grass
        { bg: '#c9edd2', text: '#218339' }, // emerald
        { bg: '#c9ede4', text: '#21836a' }, // teal
        { bg: '#c9cced', text: '#212983' }, // blue
        { bg: '#d7c9ed', text: '#452183' }, // indigo
        { bg: '#e6c9ed', text: '#6f2183' }, // violet
        { bg: '#edc9ec', text: '#83217f' }, // magenta
        { bg: '#edc9e2', text: '#832165' }, // fuchsia
        { bg: '#edc9d2', text: '#832139' }, // rose
    ],

    // Dark-theme circle palette: index-aligned to LIST_PALETTE (same hue order), so a
    // list keeps its identity hue across themes. Deep jewel tones for the night sky;
    // the label/meta text is white with a touch of opacity (NIGHT_TEXT) on all of them.
    LIST_PALETTE_DARK: [
        { bg: '#2c364a', text: NIGHT_TEXT }, // gray
        { bg: '#574125', text: NIGHT_TEXT }, // sand
        { bg: '#3c3762', text: NIGHT_TEXT }, // mauve
        { bg: '#4d4a33', text: NIGHT_TEXT }, // straw
        { bg: '#542d49', text: NIGHT_TEXT }, // pink
        { bg: '#2f3172', text: NIGHT_TEXT }, // lavender
        { bg: '#203f46', text: NIGHT_TEXT }, // sage
        { bg: '#20405e', text: NIGHT_TEXT }, // powder blue
        { bg: '#593924', text: NIGHT_TEXT }, // peach
        { bg: '#542f34', text: NIGHT_TEXT }, // salmon
        { bg: '#203170', text: NIGHT_TEXT }, // periwinkle
        { bg: '#1c3f62', text: NIGHT_TEXT }, // sky
        { bg: '#1c4b60', text: NIGHT_TEXT }, // cyan
        { bg: '#2d4b30', text: NIGHT_TEXT }, // green
        // Pick-only hues (index 14+): deep jewel versions — bg hsl(h, 40%, 25%).
        { bg: '#592626', text: NIGHT_TEXT }, // red
        { bg: '#593726', text: NIGHT_TEXT }, // orange
        { bg: '#594726', text: NIGHT_TEXT }, // amber
        { bg: '#595926', text: NIGHT_TEXT }, // yellow
        { bg: '#4f5926', text: NIGHT_TEXT }, // lime
        { bg: '#335926', text: NIGHT_TEXT }, // grass
        { bg: '#265933', text: NIGHT_TEXT }, // emerald
        { bg: '#26594d', text: NIGHT_TEXT }, // teal
        { bg: '#262b59', text: NIGHT_TEXT }, // blue
        { bg: '#392659', text: NIGHT_TEXT }, // indigo
        { bg: '#4f2659', text: NIGHT_TEXT }, // violet
        { bg: '#592658', text: NIGHT_TEXT }, // magenta
        { bg: '#59264a', text: NIGHT_TEXT }, // fuchsia
        { bg: '#592633', text: NIGHT_TEXT }, // rose
    ],
}